// Image width is stored as a percentage of the editor column (responsive +
// resolution independent — authors don't know their image's pixel size, and a
// % survives different reader viewports). null = natural full-column width.
//
// Resizing is done via preset buttons rather than a drag handle: the figure has
// an editable caption, so clicking the image lands in the caption instead of
// selecting the node — a selection-based handle never appears. Presets sidestep
// that entirely and remove the "what size?" guesswork.
export const WIDTH_PRESETS = [25, 50, 75, 100] as const;
